// extracted by mini-css-extract-plugin
module.exports = {"rule":"_18063","label":"_12493","value":"_81"};